/**
 * The HTTP status behind a thrown API error, or `null` when there is none.
 *
 * `validateApiResponse` attaches `response.status` to the Error it throws, so
 * 403 and 404 survive the trip from the envelope to the screen. Keeping the
 * read in one place is what stops a caller from collapsing them into a generic
 * "something went wrong" — which would tell a user that a colleague's record
 * does not exist when they simply lack access.
 */
export const apiErrorStatus = (error) => error?.response?.status ?? null;

export default apiErrorStatus;
